import React from 'react'
import { getTranslateByKey } from '@/main/services/utils';
import { holidaysApi } from '@/main/api';
import { HolidaysRequest} from '@/main/models/request';
import KOGPaginationGrid from '@/main/components/shared/paginationGrid/paginationGrid';
import BoxGrid from '@/main/components/shared/boxGrid/boxGrid';
import RowDataHolidays from './rowDataHolidays/rowDataHolidays';
import { HolidaysResponse } from '@/main/models/response/holidaysResponse';
import * as S from './styles';

interface IGridSearchHolidaysProps {
  dataGrid: HolidaysResponse[];
  formFilters: HolidaysRequest | null;
  setDataGrid: React.Dispatch<React.SetStateAction<HolidaysResponse[]>>;
}

function GridSearchHoliday({
  dataGrid,
  formFilters,
  setDataGrid
}: IGridSearchHolidaysProps) {
  const rowsHeader = [
    getTranslateByKey('information.date'),
    getTranslateByKey('information.description'),
    getTranslateByKey('information.recurrent'),
    <S.TextCenter>{getTranslateByKey('information.status')}</S.TextCenter>
  ]
  const RowsGroup = ['30%','40%','33%','6%']
  async function fetchDataHolidays(request: any) {
    return holidaysApi.getSearchGrid(request).then(response => response.data);
  }

  function updateRowDataGrid(row: HolidaysResponse) {
    const index = dataGrid.findIndex(item => item.guidHoliday === row.guidHoliday);
    if (index === -1) return;
    dataGrid[index] = {
      ...dataGrid[index],
      description: row.description,
      date: row.date,
      active: row.active,
      recurringFormatted: row.recurringFormatted,
      recurring: row.recurring,
    };
    setDataGrid([...dataGrid]);
  }

  if (dataGrid.length === 0 && formFilters === null) return null

  return (
    <S.Container>
      <KOGPaginationGrid
        showTitleResults
        dataGrid={dataGrid}
        formFilters={formFilters}
        setDataGrid={setDataGrid}
        fetchMore={fetchDataHolidays}
      >
        <BoxGrid rowHeaders={rowsHeader} sizeColumns={RowsGroup}>
          {dataGrid.map((item) =>
            <RowDataHolidays
              key={item.guidHoliday}
              updateRowDataGrid={updateRowDataGrid}
              holidays={item}
            />
          )}
        </BoxGrid>
      </KOGPaginationGrid>
    </S.Container>
  )
}

export default GridSearchHoliday